import { Description } from "@material-ui/icons";
import { Extra, Product } from "features/ProductReel/types";
import React from "react";
import styled from "styled-components/macro";
import { device } from "theme/Breakpoints";
import { DefaultText } from "theme/GlobalElements";
import { colors } from "theme/Theme";

interface ProductDescriptionProps {
  text?: string;
}

const ProductDescriptionText: React.FC<ProductDescriptionProps> = ({
  text,
}) => {
  return (
    <ProductDescriptionContainer>
      {text && (
        <DescriptionText
          className="text-body"
          dangerouslySetInnerHTML={{ __html: text }}
        />
      )}
    </ProductDescriptionContainer>
  );
};

const ProductDescriptionContainer = styled.div`
  background-color: white;
  display: flex;
  flex-flow: column;
  padding: 10px;
  border: 1px solid ${colors.gray};
`;
ProductDescriptionContainer.displayName = "ProductDescriptionContainer";
const DescriptionText = styled.div``;
const ItemContainer = styled.div`
  display: flex;
  flex-flow: column;
  width: 100%;

  & + & {
    margin-top: 20px;
  }

  @media only screen and (${device.tablet}) {
    flex-flow: row nowrap;
    justify-content: space-between;
  }
`;
ItemContainer.displayName = "ItemContainer";

const ItemImageContainer = styled.div`
  flex: 1;

  @media only screen and (${device.tablet}) {
    flex: 0 29%;
  }

  @media only screen and (${device.laptopL}) {
    flex: 0 19%;
  }
`;

// 4:3 aspect ration
const ItemImage = styled.img`
  width: 100%;

  @media only screen and (${device.laptop}) {
    width: 180px;
    height: 135px;
  }

  @media only screen and (${device.laptopL}) {
    width: 280px;
    height: 210px;
  }
`;

const TitleContentContainer = styled.div`
  display: flex;
  flex-flow: column;
  flex: 1;

  @media only screen and (${device.tablet}) {
    justify-content: center;
    flex: 0 69%;
  }

  @media only screen and (${device.laptopL}) {
    flex: 0 79%;
  }
`;
TitleContentContainer.displayName = "TitleContentContainer";

const ItemTitle = styled(DefaultText)`
  margin: 10px 0;
  font-weight: 700;
`;
ItemTitle.displayName = "ItemTitle";

const ItemContent = styled(DefaultText)`
  font-weight: 300;
  margin: 0;
`;
ItemContent.displayName = "ItemContent";

export default ProductDescriptionText;
